import { render, staticRenderFns } from "./RegisterQl.vue?vue&type=template&id=6a04c332&scoped=true"
import script from "./RegisterQl.vue?vue&type=script&lang=js"
export * from "./RegisterQl.vue?vue&type=script&lang=js"
import style0 from "./RegisterQl.vue?vue&type=style&index=0&id=6a04c332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a04c332",
  null
  
)

export default component.exports